import React from 'react';

import { Paper, Grid, Typography, Checkbox } from '@material-ui/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faExclamationCircle, faPowerOff } from '@fortawesome/free-solid-svg-icons';

export default function Activation({ formikProps }) {
  const isResale = !!process.env.REACT_APP_RESALE_ID;

  const { values, errors, setFieldValue } = formikProps;

  return(
    <Paper style={{ padding: 30, marginBottom: 30 }}>
      <Grid container xs={12} justify='center'>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 50, height: 50, borderRadius: '50%', backgroundColor: 'rgba(231, 116, 18, 0.15)' }}>
          <FontAwesomeIcon
            size='2x'
            color='#E77412'
            icon={faPowerOff}
          />
        </div>
      </Grid>
      <Grid container direction='column' alignItems='center' style={{ marginTop: 20, textAlign: 'center' }}>
        <Typography variant='h6'>
          <b>Novo estabelecimento será criado DESATIVADO</b>
        </Typography>
        <Typography variant='subtitle2' color='textSecondary'>
          O estabelecimento será criado desativado e só poderá ser utilizado após a ativação realizada pela equipe financeira.
        </Typography>
      </Grid>
      {!isResale && (
        <Grid container justify='flex-start' alignItems='center' style={{ gap: 10, padding: 15, marginTop: 20, backgroundColor: '#FFF2DC', border: '2px solid #FFC48A', borderRadius: 8 }}>
          <FontAwesomeIcon
            size='lg'
            color='#E77412'
            icon={faTriangleExclamation}
          />
          <Typography variant='subtitle2' style={{ color: '#893500' }}>
            <b>Entre em contato com a equipe financeira pelo WhatsApp para realizar o pagamento referente a ativação do novo estabelecimento.</b>
          </Typography>
        </Grid>
      )}
      <Grid container justify='flex-start' alignItems='center' style={{ gap: 10, padding: 15, marginTop: 20, backgroundColor: '#ecf7fe', border: '2px solid #6aa4dd', borderRadius: 8 }}>
        <FontAwesomeIcon
          size='lg'
          color='#6aa4dd'
          icon={faExclamationCircle}
        />
        <Typography variant='subtitle2' style={{ color: '#6aa4dd' }}>
          <b>Informamos que NÃO existe teste grátis para novos estabelecimentos de atuais clientes.</b>
        </Typography>
      </Grid>
      <Grid container justify='flex-start' alignItems='center' style={{ gap: 10, padding: 15, marginTop: 20, border: '2px solid #c4c4c4', borderRadius: 8 }}>
        <Checkbox
          name="deactivatedEstablishmentTerms"
          type="checkbox"
          value={values?.deactivatedEstablishmentTerms}
          checked={values?.deactivatedEstablishmentTerms}
          onChange={event => setFieldValue(event.target.name, event.target.checked)}
        />
        <Typography variant='subtitle2'>
          Estou ciente de que o novo estabelecimento será criado desativado e que não há teste grátis.
        </Typography>
        <br />
      </Grid>
      <br />
      {!!errors?.deactivatedEstablishmentTerms && (
        <Typography color='error'>
          {errors?.deactivatedEstablishmentTerms}
        </Typography>
      )}
      <Grid container justify='flex-start' alignItems='center' style={{ gap: 10, padding: 15, marginTop: 20, border: '2px solid #c4c4c4', borderRadius: 8 }}>
        <Checkbox
          name="businessDayActivationTerms"
          type="checkbox"
          value={values?.businessDayActivationTerms}
          checked={values?.businessDayActivationTerms}
          onChange={event => setFieldValue(event.target.name, event.target.checked)}
        />
        <Typography variant='subtitle2'>
          Ciente que a ativação ocorrerá apenas em dia útil
        </Typography>
        <br />
      </Grid>
      <br />
      {!!errors?.businessDayActivationTerms && (
        <Typography color='error'>
          {errors?.businessDayActivationTerms}
        </Typography>
      )}
    </Paper>
  );
}